import { Route, Routes } from "react-router-dom";
import FoldersPage from "../../app/folders";
import FolderIdPage from "../../app/folders/id";
import MultireportPreviewPage from "../../app/folders/id/multireport";

export default function FolderRoutes() {
  return (
    <Routes>
      <Route path="/" element={<FoldersPage />} />
      <Route path="/:id" element={<FolderIdPage />} />
      <Route
        path="/:folderNumber/multireport/preview"
        element={<MultireportPreviewPage />}
      />
    </Routes>
  );
}
